"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatsListingPriceAttributes$ = exports.StatsListingPriceAttributes$outboundSchema = exports.StatsListingPriceAttributes$inboundSchema = void 0;
exports.statsListingPriceAttributesToJSON = statsListingPriceAttributesToJSON;
exports.statsListingPriceAttributesFromJSON = statsListingPriceAttributesFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
const listingpricewrapper_js_1 = require("./listingpricewrapper.js");
/** @internal */
exports.StatsListingPriceAttributes$inboundSchema = z.object({
    end_date: z.string().datetime({ offset: true }).transform(v => new Date(v)),
    start_date: z.string().datetime({ offset: true }).transform(v => new Date(v)),
    stats: listingpricewrapper_js_1.ListingPriceWrapper$inboundSchema,
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "end_date": "endDate",
        "start_date": "startDate",
    });
});
/** @internal */
exports.StatsListingPriceAttributes$outboundSchema = z.object({
    endDate: z.date().transform(v => v.toISOString()),
    startDate: z.date().transform(v => v.toISOString()),
    stats: listingpricewrapper_js_1.ListingPriceWrapper$outboundSchema,
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        endDate: "end_date",
        startDate: "start_date",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var StatsListingPriceAttributes$;
(function (StatsListingPriceAttributes$) {
    /** @deprecated use `StatsListingPriceAttributes$inboundSchema` instead. */
    StatsListingPriceAttributes$.inboundSchema = exports.StatsListingPriceAttributes$inboundSchema;
    /** @deprecated use `StatsListingPriceAttributes$outboundSchema` instead. */
    StatsListingPriceAttributes$.outboundSchema = exports.StatsListingPriceAttributes$outboundSchema;
})(StatsListingPriceAttributes$ || (exports.StatsListingPriceAttributes$ = StatsListingPriceAttributes$ = {}));
function statsListingPriceAttributesToJSON(statsListingPriceAttributes) {
    return JSON.stringify(exports.StatsListingPriceAttributes$outboundSchema.parse(statsListingPriceAttributes));
}
function statsListingPriceAttributesFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.StatsListingPriceAttributes$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'StatsListingPriceAttributes' from JSON`);
}
//# sourceMappingURL=statslistingpriceattributes.js.map